import { css } from '@emotion/core';

// mobile first, default breakpoints use min-width
// mobile: < 576px
// small: 576px - 767px
// medium: 768px - 991px
// large: >= 1200px
const breakpoints = {
    mobile: 320,
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200
};

const mediaQueries = {};

export const mq = Object.keys(breakpoints).reduce((accumulator, label) => {
    const prefix = typeof breakpoints[label] === 'string' ? '' : 'min-width:';
    const suffix = typeof breakpoints[label] === 'string' ? '' : 'px';
    mediaQueries[label] = styles =>
        css`
            @media (${prefix + breakpoints[label] + suffix}) {
                ${styles};
            }
        `;
    return mediaQueries;
}, {});

export const mqPrint = styles => css`
    @media only print {
        ${styles};
    }
`;
